import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {Boxed} from "../../../hiberUiKit/src/molecules/Boxed/Boxed";
import Routes from "../../../navigation/route/Route";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import PartnerBrand from "../../../model/partnerBrand/PartnerBrand";
import UpdatePartnerBrandForm from "./form/update/UpdatePartnerBrandForm";
import {OnFailure} from "../../../store/action/actionHelpers";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {Dispatch} from "redux";
import {fetchPartnerBrand} from "../../../store/action/partnerBrand/partnerBrand";

interface ReduxProps {
	partnerBrand?: PartnerBrand;
}

interface RouteProps {
	partnerBrandId: string
}

interface DispatchProps {
	fetchPartnerBrand: (id: string, onFailure: OnFailure) => void
}

type Props = RouteComponentProps<RouteProps> & ReduxProps & DispatchProps;

/**
 * Create brand.
 */
class PartnerBrandUpdate extends React.PureComponent <Props> {

	componentDidMount(): void {
		this.props.fetchPartnerBrand(this.props.match.params.partnerBrandId,
			(e) => {
				notifyBugsnagAndShowToast(e, "Fetch partner brand");
				this.navigateToPartnerBrandList()
			})
	}

	render() {
		if (!this.props.partnerBrand)
			return null;

		return (
			<Boxed>
				{/* The form view draws its own header: the Actions menu there needs the form's unsaved state. */}
				<UpdatePartnerBrandForm partnerBrand={this.props.partnerBrand}/>
			</Boxed>
		);
	}

	/**
	 * On brand edited.
	 */
	private navigateToPartnerBrandList = () => this.props.history.push(Routes.PartnerBrandList);
}

function mapStateToProps(state: RootState, props: RouteComponentProps<RouteProps>) {
	return {
		partnerBrand: state.partnerBrand.partnerBrandsMap[props.match.params.partnerBrandId]
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchPartnerBrand: (id: string, onFailure: OnFailure) => dispatch(fetchPartnerBrand(id, onFailure))
	}
}

export default withRouter(connect<ReduxProps>(mapStateToProps, mapDispatchToProps)(PartnerBrandUpdate));
